function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RcColor } from '../../hooks/color';
import React from 'react';
import { ColorContent } from './components/ColorContent';
import { Hue } from './Hue';
import { Saturation } from './Saturation';
export function ColorPanel(props) {
  var children = props.children,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      value = props.value,
      hasAlpha = props.hasAlpha,
      _props$format = props.format,
      format = _props$format === void 0 ? 'hex' : _props$format,
      extra = _objectWithoutProperties(props, ["children", "onChange", "onValueChange", "value", "hasAlpha", "format"]);

  return React.createElement(RcColor, {
    hasAlpha: hasAlpha,
    value: value,
    format: format,
    onChange: onChange,
    onValueChange: onValueChange
  }, React.createElement(ColorContent, Object.assign({
    hasAlpha: hasAlpha
  }, extra), children));
}
ColorPanel.Hue = Hue;
ColorPanel.Saturation = Saturation;